<template>
  <div>
    <div class="loading-overlay" v-if="isLoading">
      <div class="spinner-border text-danger" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
      :btnToLink="'/race_series/add'"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>

    <h5>検索</h5>
    <div class="w100 mb-5">
      <div>
        <div class="row mb-1">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-6">移行状況</p>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <bs-select
                :options="step_list"
                v-model="sprm.step"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-6">メール変更</p>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <bs-select
                :options="mail_flg_list"
                v-model="sprm.chg_mail_flg"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-6">ライセンスNo</p>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <input
                type="text"
                v-model="sprm.license_no"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-6">名前</p>
          </div>
          <div class="col-5 mb-2">
            <div class="input-group">
              <input
                type="text"
                v-model="sprm.like_name"
                class="form-control"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col text-center"></div>
          <div class="col text-center">
            <bs-button
              :btnClass="'btn-primary'"
              @to_click_event="search_migration()"
              >条件で検索</bs-button
            >
          </div>
          <div class="col text-end">
            <bs-button
              :btnClass="'btn-light btn-outline-secondary'"
              @to_click_event="clear"
              >検索条件クリア</bs-button
            >
          </div>
        </div>
      </div>
    </div>

    <div
      class="w100"
      v-if="
        typeof migration_list === 'object' &&
        Object.keys(migration_list).length > 0
      "
    >
      <table class="table">
        <thead>
          <tr>
            <th style="width: 7%">状況</th>
            <th style="width: 10%">ライセンスNo</th>
            <th style="width: 7%">生年月日</th>
            <th style="width: 10%">名前</th>
            <th style="width: 10%">メールアドレス</th>
            <th style="width: 7%">メール変更</th>
            <th colspan="1" style="width: 12%">action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in migration_list" :key="list.id">
            <td>{{ get_list_label(list.step, step_list) }}</td>
            <td>{{ list.license_no }}</td>
            <td>{{ list.birth_date }}</td>
            <td>{{ get_migration_name(list.id) }}</td>
            <!-- <td v-html="get_migration_mail(list.id).replace(',', '<br>')"></td> -->
            <td v-if="!get_migration_mail(list.id)">-</td>
            <td v-else>
              <div
                v-html="get_migration_mail(list.id).replace(',', '<br>')"
              ></div>
            </td>
            <td>{{ get_list_label(list.chg_mail_flg, mail_flg_list) }}</td>
            <td>
              <bs-button
                :btnClass="'btn-light btn-sm btn-outline-secondary'"
                @to_click_event="handleClick(list.id)"
                >詳細</bs-button
              >
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-8">
          <bs-page-nav
            :pager_key="'migration_list'"
            @to_click_event="pageAction"
          ></bs-page-nav>
        </div>
        <div class="col-4">
          <div class="d-grid">
            <button @click="downloadMigrationList" class="btn btn-warning">
              ダウンロード
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import '../../assets/bootstrap/css/sc.css';
// import Common from '../common/common'
import BsSelect from '../../atoms/BsSelect.vue'
import BsButton from '../../atoms/BsButton.vue'
import BsPageNav from '../../molecules/BsPageNav.vue'
import config from '../../../const'

export default {
  name: 'MigrationListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: '移行データ一覧',
      fromParentBtn: '',
      migration_obj: [],
      sprm: {
        step: '',
        lisence_no: '',
        like_name: ''
      },
      mail_flg_list: [
        {
          key: 0,
          label: '変更しない'
        },
        {
          key: 1,
          label: '変更する'
        }
      ],
      step_list: [
        {
          key: 0,
          label: '移行前'
        },
        {
          key: 1,
          label: 'メール送信'
        },
        {
          key: 5,
          label: 'メール確認済'
        },
        {
          key: 7,
          label: '申請内容チェック'
        },
        {
          key: 10,
          label: '移行済'
        }
      ],
      page: 0,
      page_limit: 10,
      isLoading: false
    }
  },
  components: {
    BsPageTitle,
    BsButton,
    BsMsgAlert,
    BsSelect,
    BsPageNav
  },
  computed: {
    ...mapState({}),

    get_list_label: function () {
      return function (key, lists) {
        // if (key === '0') return '未選択'
        if (
          typeof lists === 'object' &&
          typeof lists.find(list => list.key == key) === 'object'
        ) {
          return lists.find(list => list.key == key).label
        }
        return key
      }
    },
    migration_list: function () {
      const lists = [...this.migration_obj]
      return lists
    },
    get_migration_name: function () {
      const lists = this.migration_list
      return function (migration_id) {
        if (
          typeof lists === 'object' &&
          lists.find(list => list.id == migration_id) &&
          typeof lists.find(list => list.id == migration_id)?.member ===
            'object' &&
          (lists.find(list => list.id == migration_id)?.member?.name_1 ||
            lists.find(list => list.id == migration_id)?.member?.name_2)
        ) {
          let name = lists.find(list => list.id == migration_id)?.member?.name_1
          name += lists.find(list => list.id == migration_id)?.member?.name_2
          return name
        }
        return migration_id
      }
    },
    get_migration_mail: function () {
      const lists = this.migration_list
      return function (migration_id) {
        if (
          typeof lists === 'object' &&
          lists.find(list => list.id == migration_id) &&
          typeof lists.find(list => list.id == migration_id)?.items ===
            'object' &&
          lists
            .find(list => list.id == migration_id)
            ?.items.find(
              item =>
                item.migration_key == 'mail_address' ||
                item.migration_key == 'up_mail_address'
            )
        ) {
          return lists
            .find(list => list.id == migration_id)
            ?.items.find(
              item =>
                item.migration_key == 'mail_address' ||
                item.migration_key == 'up_mail_address'
            )?.migration_value
        } else if (
          typeof lists === 'object' &&
          lists.find(list => list.id == migration_id) &&
          typeof lists.find(list => list.id == migration_id)?.member ===
            'object' &&
          (lists.find(list => list.id == migration_id)?.member?.mail_1 ||
            lists.find(list => list.id == migration_id)?.member?.mail_2)
        ) {
          let mail = lists.find(list => list.id == migration_id)?.member?.mail_1
          if (lists.find(list => list.id == migration_id)?.member?.mail_2) {
            mail +=
              ',' + lists.find(list => list.id == migration_id)?.member?.mail_2
          }
          return mail
        } else {
          return ''
        }
      }
    }
  },

  async created() {
    // await this.loadMigrationList()
  },
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = '移行データ一覧です'
  },

  methods: {
    clear() {
      const params = { ...this.sprm }
      if (typeof params === 'object') {
        Object.keys(params).forEach(sprm_key => {
          params[sprm_key] = ''
        })
      }
      this.sprm = params
      this.$store.dispatch('setSearchParam', {
        data: params,
        target: 'license_cd'
      })
    },
    async search_migration() {
      this.isLoading = true
      try {
        await new Promise(resolve => setTimeout(resolve, 500))
        this.page = 0
        await this.loadMigrationList()
      } finally {
        this.isLoading = false
      }
    },
    async pageAction(page) {
      this.page = page
      await this.loadMigrationList()
    },
    async downloadMigrationList() {
      const params = {}
      params['stat'] = [1]
      if (typeof this.sprm === 'object') {
        Object.keys(this.sprm).forEach(param_key => {
          if (this.sprm[param_key]) {
            params[param_key] = this.sprm[param_key]
          }
        })
      }
      params['pagelimit'] = false
      await this.basicPosts_S(
        config.BASE_API_URL + '/member_migration/output_csv',
        params
      )
        .then(async response => {
          console.log('loadMemberList download response', response)
          console.log('loadMemberList download response2', response.data.body)
          window.open(
            config.BASE_API_URL +
              '/member_migration/download?file=' +
              response.data.body,
            '_blank'
          )
        })
        .catch(async err => {
          console.log(err)
          // this.migration_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadMigrationList() {
      const params = {}
      params['stat'] = [1]
      if (typeof this.sprm === 'object') {
        Object.keys(this.sprm).forEach(param_key => {
          if (this.sprm[param_key]) {
            params[param_key] = this.sprm[param_key]
          }
        })
      }
      params['pagelimit'] = 30
      if (this.page >= 0) params['p'] = this.page
      // params['pageorder'] = 'mfj_member_migration_member.id'
      // params['pageorder'] = this.page_order;
      params['pagesort'] = 'ASC'
      this.$store.dispatch('setSearchParam', {
        data: params,
        target: 'migration_list'
      })
      console.log('loadMigrationList params', params)
      await this.basicPosts_S(
        config.BASE_API_URL + '/member_migration/lists',
        params
      )
        .then(async response => {
          console.log('loadMigrationList response', response)
          this.migration_obj =
            response.data && response.data.body ? response.data.body : []

          this.$store.dispatch('setSearchParam', {
            data: params,
            target: 'migration_list'
          })
          const setPageData = {}
          setPageData.data =
            response.data && response.data.pager ? response.data.pager : {}
          setPageData.target = 'migration_list'
          this.$store.dispatch('setPager', setPageData)
        })
        .catch(async err => {
          console.log(err)
          this.migration_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    handleClick(target) {
      this.$router.push({ path: '/migration/' + target + '/' })
    }
  }
}
</script>
